import { render, staticRenderFns } from "./GalaList.vue?vue&type=template&id=08d819e4&scoped=true&"
import script from "./GalaList.vue?vue&type=script&lang=js&"
export * from "./GalaList.vue?vue&type=script&lang=js&"
import style0 from "./GalaList.vue?vue&type=style&index=0&id=08d819e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d819e4",
  null
  
)

export default component.exports